"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = exports.DialogTypes = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactJss = require("react-jss");
var _Flex = _interopRequireDefault(require("../Flex"));
var _Dialog = require("../../components/Dialog/Dialog.styles");
var _FlatButton = _interopRequireDefault(require("../../components/FlatButton"));
var _Modal = _interopRequireDefault(require("../../components/Modal"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _environmentCharacteristics = require("../../utils/environmentCharacteristics");
var _splitCommonFromProps11 = _interopRequireDefault(require("../../utils/splitCommonFromProps"));
var _excluded = ["width", "height", "zIndex"],
  _excluded2 = ["children", "confirmLabel", "confirmOnClick", "container", "content", "denyLabel", "denyOnClick", "enforceOverflow", "icon", "open", "overrides", "singleAction", "title", "type", "small", "trapFocus"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var DialogTypes = exports.DialogTypes = /*#__PURE__*/function (DialogTypes) {
  DialogTypes["ERROR"] = "error";
  DialogTypes["INFO"] = "info";
  DialogTypes["WARNING"] = "warning";
  return DialogTypes;
}({});
var useDialogFill = function useDialogFill(type) {
  var theme = (0, _reactJss.useTheme)();
  return {
    error: theme.colors.alert,
    info: theme.colors.info,
    warning: theme.colors.warning
  }[type] || theme.colors.baseContrast050;
};
var Dialog = function Dialog(props) {
  var _splitCommonFromProps = (0, _splitCommonFromProps11.default)(props, _Dialog.dialogCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    _splitCommonFromProps3 = _splitCommonFromProps2[0],
    width = _splitCommonFromProps3.width,
    height = _splitCommonFromProps3.height,
    zIndex = _splitCommonFromProps3.zIndex,
    common = _objectWithoutProperties(_splitCommonFromProps3, _excluded),
    _splitCommonFromProps4 = _splitCommonFromProps2[1],
    children = _splitCommonFromProps4.children,
    _splitCommonFromProps5 = _splitCommonFromProps4.confirmLabel,
    confirmLabel = _splitCommonFromProps5 === void 0 ? "ok" : _splitCommonFromProps5,
    confirmOnClick = _splitCommonFromProps4.confirmOnClick,
    _splitCommonFromProps6 = _splitCommonFromProps4.container,
    container = _splitCommonFromProps6 === void 0 ? _environmentCharacteristics.isBrowser ? document.body : undefined : _splitCommonFromProps6,
    content = _splitCommonFromProps4.content,
    _splitCommonFromProps7 = _splitCommonFromProps4.denyLabel,
    denyLabel = _splitCommonFromProps7 === void 0 ? "cancel" : _splitCommonFromProps7,
    denyOnClick = _splitCommonFromProps4.denyOnClick,
    enforceOverflow = _splitCommonFromProps4.enforceOverflow,
    icon = _splitCommonFromProps4.icon,
    open = _splitCommonFromProps4.open,
    _splitCommonFromProps8 = _splitCommonFromProps4.overrides,
    overrides = _splitCommonFromProps8 === void 0 ? {} : _splitCommonFromProps8,
    _splitCommonFromProps9 = _splitCommonFromProps4.singleAction,
    singleAction = _splitCommonFromProps9 === void 0 ? false : _splitCommonFromProps9,
    title = _splitCommonFromProps4.title,
    type = _splitCommonFromProps4.type,
    small = _splitCommonFromProps4.small,
    _splitCommonFromProps10 = _splitCommonFromProps4.trapFocus,
    trapFocus = _splitCommonFromProps10 === void 0 ? true : _splitCommonFromProps10,
    otherProps = _objectWithoutProperties(_splitCommonFromProps4, _excluded2);
  var fill = useDialogFill(type);
  var classes = (0, _Dialog.useDialogStyles)(_Dialog.dialogVars.useVars(_objectSpread({
    width: width,
    height: height,
    fill: fill,
    zIndex: zIndex
  }, common)));
  var dialogBoxStyles = (0, _classnames.default)(classes.defaultDialogBoxStyles, classes.variables, overrides.dialogBox, _defineProperty({}, classes.small, small));
  var overrideDefaults = {
    modalRoot: overrides.dialogRoot,
    modalOverlay: overrides.dialogOverlay,
    modalBox: dialogBoxStyles
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, _extends({
    dismissible: false,
    open: open,
    container: container,
    disableCloseButton: true,
    overrides: overrideDefaults,
    enforceOverflow: enforceOverflow,
    trapFocus: trapFocus
  }, otherProps), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, overrides.root)
  }, (type || title) && /*#__PURE__*/_react.default.createElement("h2", {
    className: (0, _classnames.default)(classes.title, _defineProperty({}, classes.noContent, !content && !children), overrides.title)
  }, type ? /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    name: type,
    className: classes.svgIcon
  }) : icon, title), content && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(classes.content, overrides.content)
  }, content), children, /*#__PURE__*/_react.default.createElement(_Flex.default, {
    direction: "row",
    justifyContent: "end",
    gap: "$1",
    className: classes.actions
  }, !singleAction && /*#__PURE__*/_react.default.createElement(_FlatButton.default, {
    label: denyLabel,
    onClick: denyOnClick,
    className: (0, _classnames.default)(classes.button, overrides.denyButton)
  }), /*#__PURE__*/_react.default.createElement(_FlatButton.default, {
    label: confirmLabel,
    primary: true,
    onClick: confirmOnClick,
    className: (0, _classnames.default)(classes.button, overrides.confirmButton)
  }))));
};
Dialog.displayName = "Dialog";
var Storybook = exports.Storybook = Dialog;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/overlay-dialog--docs
 */
var exportedComponent = (0, _defaultProps.default)(Dialog);
exportedComponent.displayName = "Dialog";
var _default = exports.default = exportedComponent;